import {
    booleanFormatter,
    daysLeftColorFormatter,
    integerFormatter,
    percentageBarFormatter,
    redNegativeFormatter,
    tenProductRound,
    capacityScoreFormatter,
    powerStateFormatter,
    numberFormatter,
    currentFormatter, dateFormatter
} from "../../gridFormatters";
import { usedPct, wtAvg, wtPctAvg } from "../../math";

export const clusterUnitDefs = [
    {
        field: "cluster_name",
        headerName: "Cluster Name",
    },
    {
        field: "vcenter_name",
        headerName: "VCenter Name",
    },
    {
        field: "total_vms",
        type: "numericColumn",
        cellRenderer: integerFormatter,
        headerName: "Total VM/LPARs",
        filter: "agNumberColumnFilter",
        aggFunc: "sum"
    },
    {
        field: "total_cpus",
        type: "numericColumn",
        cellRenderer: numberFormatter,
        headerName: "Total CPU's",
        filter: "agNumberColumnFilter",
        aggFunc: "sum"
    },
    {
        field: "cpu_util_pct",
        headerName: "Avg % CPU Util",
        type: "numericColumn",
        cellRenderer: percentageBarFormatter,
        enableValue: true,
        aggFunc: "avg",
        cellStyle: {
            textAlign: "right"
        },
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
    },
    {
        field: "memory_util_pct",
        cellRenderer: percentageBarFormatter,
        type: "numericColumn",
        headerName: "Avg % Memory Util",
        filter: "agNumberColumnFilter",
        aggFunc: "avg"
    },
    {
        field: "total_disk_allocated",
        type: "numericColumn",
        headerName: "Total Disk Allocated (GiB)",
        filter: "agNumberColumnFilter",
        cellRenderer: numberFormatter,
        aggFunc: "sum"
    },
    {
        field: "disk_util_pct",
        cellRenderer: percentageBarFormatter,
        type: "numericColumn",
        headerName: "% Disk Used",
        filter: "agNumberColumnFilter",
        aggFunc: "avg",
    },
    {
        field: "total_hosts",
        cellRenderer: integerFormatter,
        type: "numericColumn",
        headerName: "# of Hosts",
        filter: "agNumberColumnFilter",
        aggFunc: "sum"
    },
    {
        field: "vm_build_capacity",
        type: "numericColumn",
        headerName: "VM Build Capacity",
        cellRenderer: redNegativeFormatter,
        filter: "agNumberColumnFilter",
        aggFunc: "sum"
    },
    {
        field: "current",
        headerName: "Days Old",
        filter: "agSetColumnFilter",
        cellRenderer: currentFormatter,
        cellStyle: {
            textAlign: "center"
        },
        aggFunc: "max",
        hide: true,
    },
    {
        field: "total_mhz",
        type: "numericColumn",
        headerName: "Total MHz",
        filter: "agNumberColumnFilter",
        cellRenderer: numberFormatter,
        aggFunc: "sum",
        hide: true,
    },
    {
        field: "max_cpu_utilization",
        headerName: "Highest % CPU Util",
        type: "numericColumn",
        cellRenderer: percentageBarFormatter,
        enableValue: true,
        aggFunc: "max",
        cellStyle: {
            textAlign: "right"
        },
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        hide: true,
    },
    {
        field: "avg_ghz_per_cpu",
        type: "numericColumn",
        headerName: "Avg GHz/CPU",
        aggFunc: "avg",
        filter: "agNumberColumnFilter",
        cellRenderer: numberFormatter,
        hide: true,
    },
    {
        field: "total_memory",
        headerName: "Total Memory (GiB)",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        cellRenderer: numberFormatter,
        aggFunc: "sum",
        hide: true,
    },
    {
        field: "max_memory_util",
        cellRenderer: percentageBarFormatter,
        type: "numericColumn",
        headerName: "Highest % Memory Util",
        filter: "agNumberColumnFilter",
        aggFunc: "max",
        hide: true,
    },
    {
        field: "total_disk_used",
        type: "numericColumn",
        headerName: "Total Disk Used (GiB)",
        filter: "agNumberColumnFilter",
        cellRenderer: numberFormatter,
        aggFunc: "sum",
        hide: true,
    },
    {
        field: "device_type_code",
        headerName: "Device Type Code",
        hide: true,
    },
    {
        field: "average_vm_cpu_size",
        headerName: "AVG VM CPU Size",
        cellRenderer: numberFormatter,
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        aggFunc: "avg",
        hide: true,
    },
    {
        field: "average_vm_memory_size",
        headerName: "AVG VM Memory Size",
        cellRenderer: numberFormatter,
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        aggFunc: "avg",
        hide: true,
    },
    {
        field: "average_vm_disk_size",
        headerName: "AVG VM Disk Size",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        cellRenderer: numberFormatter,
        aggFunc: "avg",
        hide: true,
    },
    {
        field: "vm_cpu_build_capacity",
        headerName: "VM CPU Build Capacity",
        type: "numericColumn",
        cellRenderer: integerFormatter,
        filter: "agNumberColumnFilter",
        aggFunc: "sum",
        hide: true,
    },
    {
        field: "vm_memory_build_capacity",
        headerName: "VM Memory Build Capacity",
        type: "numericColumn",
        cellRenderer: integerFormatter,
        filter: "agNumberColumnFilter",
        aggFunc: "sum",
        hide: true,
    },
    {
        field: "vms_growth_rate",
        headerName: "VMs Build Monthly Growth Rate ",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        aggFunc: "avg",
        hide: true,
    },
    {
        field: "memory_growth_rate",
        headerName: "Memory Usage Monthly Growth Rate ",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        aggFunc: "avg",
        hide: true,
    },
    {
        field: "disk_growth_rate",
        headerName: "Disk Usage Monthly Growth Rate ",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        aggFunc: "avg",
        hide: true,
    },
    {
        field: "cpu_growth_rate",
        headerName: "CPUs Usage Monthly Growth Rate ",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        aggFunc: "avg",
        hide: true,
    },
    {
        field: "vm_disk_build_capacity",
        headerName: "VM Disk Build Capacity",
        type: "numericColumn",
        cellRenderer: integerFormatter,
        filter: "agNumberColumnFilter",
        aggFunc: "sum",
        hide: true,
    },
    {
        field: "days_left_to_capacity",
        headerName: "Weeks Left to Capacity",
        type: "numericColumn",
        cellRenderer: daysLeftColorFormatter,
        filter: "agNumberColumnFilter",
        aggFunc: "max",
        hide: true,
    },
    {
        field: "capacity_constrain_str",
        headerName: "Capacity Constraint",
        hide: true
    },
    {
        field: "total_virtual_cpus",
        headerName: "Total Virtual CPUs",
        type: "numericColumn",
        cellRenderer: numberFormatter,
        filter: "agNumberColumnFilter",
        aggFunc: "sum",
        hide: true,
    },
    {
        field: "total_virtual_cpus_used",
        headerName: "Total Virtual CPUs Used",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        cellRenderer: numberFormatter,
        aggFunc: "sum",
        hide: true,
    },
    {
        field: "vcpus_pcpus_ratio",
        headerName: "Virtual to Physical CPU Ratio",
        cellRenderer: numberFormatter,
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        aggFunc: "avg",
        hide: true,
    },
    {
        field: "parent_datacenter",
        headerName: "Parent Datacenter",
        hide: true,
    },
    {
        field: "tagging_description",
        headerName: "Tagging Description",
        hide: true,
    },
    {
        field: "datacenter_name",
        headerName: "Data Center",
        hide: true,
    },
     {
        field: "category",
        headerName: "Category",
        hide: true,
    },
    {
        field: "func",
        headerName: "Func",
        hide: true,
    },
    {
        field: "type",
        headerName: "Type",
        hide: true,
    },
    {
        field: "role",
        headerName: "Role",
        hide: true,
    },
    {
        field: "failover_cluster",
        headerName: "Failover Cluster",
        hide: true,
    },
    {
        field: "inst",
        headerName: "Inst",
        type: "numericColumn",
        cellRenderer: integerFormatter,
        filter: "agNumberColumnFilter",
        aggFunc: "sum",
        hide: true,
    },
    {
        field: "pct_calc_cpu",
        headerName: "% Calc CPU",
        type: "numericColumn",
        cellRenderer: percentageBarFormatter,
        filter: "agNumberColumnFilter",
        aggFunc: "avg",
        hide: true,
    },
    {
        field: "pct_calc_memory",
        headerName: "% Calc Memory",
        type: "numericColumn",
        cellRenderer: percentageBarFormatter,
        filter: "agNumberColumnFilter",
        aggFunc: "avg",
        hide: true,
    },
    {
        field: "pct_calc_disk",
        headerName: "% Calc Disk",
        type: "numericColumn",
        cellRenderer: percentageBarFormatter,
        filter: "agNumberColumnFilter",
        aggFunc: "avg",
        hide: true,
    },
    {
        field: "num_of_failover_hosts",
        headerName: "# Failover Hosts",
        type: "numericColumn",
        cellRenderer: integerFormatter,
        filter: "agNumberColumnFilter",
        aggFunc: "sum",
        hide: true,
    },
    {
        field: "failover_class",
        headerName: "Failover Class",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        hide: true,
    },
    {
        field: "running_n_1_flag",
        headerName: "running_n_1_flag",
        cellRenderer: "booleanFormatter",
        hide: true,
    },
    {
        field: "virtualized",
        headerName: "Virtualized",
        cellRenderer: booleanFormatter,
        hide: true,
    },
    {
        field: "inactive_vms_gt_vmbuild_flag",
        headerName: "inactive_vms_gt_vmbuild_flag",
        cellRenderer: booleanFormatter,
        hide: true,
    },
    {
        field: "company_name",
        headerName: "Company Name",
        enableValue: true,
        hide: true,
    },
    {
        field: "drs_fully_enabled",
        headerName: "Drs Fully Enabled",
        hide: true,
    },
      {
        field: "host_core_savings",
        headerName: "Host Core Savings",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        hide: true,
    },
      {
        field: "host_rightsize_recommend",
        headerName: "Host Rightsize Recommend",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        hide: true,
    },
      {
        field: "host_rightsize_savings",
        headerName: "Host Rightsize Savings",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        hide: true,
    },
];

export const datastoreDefs = [
    {
        field: "datastore_name",
        headerName: "Datastore Name",
        filter: "agTextColumnFilter"
    },
    {
        field: "vcenter_name",
        headerName: "VCenter Name",
        filter: "agTextColumnFilter"
    },
    {
        field: "datastore_size",
        type: "numericColumn",
        headerName: "Size",
        filter: "agNumberColumnFilter",
        cellRenderer: numberFormatter,
        aggFunc: "sum"
    },
    {
        field: "datastore_used",
        type: "numericColumn",
        headerName: "Used",
        filter: "agNumberColumnFilter",
        cellRenderer: numberFormatter,
        aggFunc: "sum"
    },
    {
        field: "pct_used",
        type: "numericColumn",
        headerName: "% Storage Util",
        filter: "agNumberColumnFilter",
        cellRenderer: percentageBarFormatter,
        aggFunc: p => wtPctAvg(p, "datastore_used", "datastore_size"),
    },
    {
        field: "num_vms",
        cellRenderer: integerFormatter,
        type: "numericColumn",
        headerName: "Num VM/LPARs",
        filter: "agNumberColumnFilter",
        aggFunc: "sum"
    },
    {
        field: "sum_vmdks",
        cellRenderer: integerFormatter,
        type: "numericColumn",
        headerName: "Sum of VMDKs",
        filter: "agNumberColumnFilter",
        aggFunc: "sum"
    },
    {
        field: "vmdk_alloc_pct_used",
        type: "numericColumn",
        headerName: "% VMDK Allocation Used",
        filter: "agNumberColumnFilter",
        cellRenderer: percentageBarFormatter,
        aggFunc: "avg"
    },
    {
        field: "datastore_id",
        headerName: "Datastore ID",
        filter: "agTextColumnFilter",
        hide: true,
    },
    {
        field: "cluster_name",
        headerName: "Cluster Name",
        filter: "agTextColumnFilter",
        hide: true,
    },
    {
        field: "current",
        headerName: "Days Old",
        filter: "agSetColumnFilter",
        cellRenderer: currentFormatter,
        cellStyle: {
            textAlign: "center"
        },
        aggFunc: "max",
        hide: true,
    },
    {
        field: "num_hosts",
        cellRenderer: integerFormatter,
        type: "numericColumn",
        headerName: "Num Hosts",
        filter: "agNumberColumnFilter",
        aggFunc: "sum",
        hide: true,
    },
    {
        field: "disk_type",
        headerName: "Disk Type",
        filter: "agTextColumnFilter",
        hide: true,
    },
    {
        field: "over_provisioned",
        type: "numericColumn",
        headerName: "Over Provisioned",
        filter: "agNumberColumnFilter",
        cellRenderer: numberFormatter,
        aggFunc: "sum",
        hide: true,
    },
    {
        field: "free",
        type: "numericColumn",
        headerName: "Free",
        filter: "agNumberColumnFilter",
        cellRenderer: numberFormatter,
        aggFunc: "sum",
        hide: true,
    },
    {
        field: "allocated",
        type: "numericColumn",
        headerName: "Allocated",
        filter: "agNumberColumnFilter",
        cellRenderer: numberFormatter,
        aggFunc: "sum",
        hide: true,
    },
    {
        field: "usable",
        type: "numericColumn",
        headerName: "Usable",
        filter: "agNumberColumnFilter",
        cellRenderer: numberFormatter,
        aggFunc: "sum",
        hide: true,
    },
    {
        field: "datacenter_name",
        headerName: "Data Center",
        hide: true,
    },
    {
        field: "tag_1",
        headerName: "Tag 1",
        hide: true,
    },
    {
        field: "tag_2",
        headerName: "Tag 2",
        hide: true,
    },
    {
        field: "tag_3",
        headerName: "Tag 3",
        hide: true,
    },
    {
        field: "state_tag",
        headerName: "State Tag",
        hide: true,
    },
];

export const hostsDefs = [
    {
        field: "esx_host_name",
        headerName: "ESX Host Name",
    },
    {
        field: "vcenter_name",
        headerName: "VCenter Name",
    },
    {
        field: "cluster_name",
        headerName: "Cluster Name",
    },
    {
        field: "model",
        headerName: "Model",
    },
    {
        field: "version",
        headerName: "OS Version",
    },
    {
        field: "total_vms",
        type: "numericColumn",
        cellRenderer: integerFormatter,
        headerName: "Total VM/LPARs",
        filter: "agNumberColumnFilter",
        aggFunc: "sum"
    },
    {
        field: "total_cpus",
        type: "numericColumn",
        cellRenderer: numberFormatter,
        aggFunc: "sum",
        headerName: "Total CPU's",
        filter: "agNumberColumnFilter"
    },
    {
        field: "cpu_util_pct",
        type: "numericColumn",
        aggFunc: "avg",
        cellRenderer: percentageBarFormatter,
        headerName: "Avg % CPU Util",
        filter: "agNumberColumnFilter"
    },
    {
        field: "total_memory",
        type: "numericColumn",
        cellRenderer: numberFormatter,
        headerName: "Total Memory",
        aggFunc: "sum",
        filter: "agNumberColumnFilter"
    },
    {
        field: "memory_util_pct",
        cellRenderer: percentageBarFormatter,
        type: "numericColumn",
        headerName: "Avg % Memory Util",
        aggFunc: "avg",
        filter: "agNumberColumnFilter"
    },
    {
        field: "vm_build_capacity",
        type: "numericColumn",
        headerName: "VM Build Capacity",
        aggFunc: "sum",
        filter: "agNumberColumnFilter"
    },
    {
        field: "end_of_support",
        headerName: "End of Support",
        filter: "agDateColumnFilter",
        cellRenderer: dateFormatter,
        hide: true
    },
    {
        field: "end_of_service_life",
        headerName: "End of Service Life",
        filter: "agDateColumnFilter",
        cellRenderer: dateFormatter,
        hide: true
    },
    {
        field: "current",
        headerName: "Days Old",
        filter: "agSetColumnFilter",
        cellRenderer: currentFormatter,
        cellStyle: {
            textAlign: "center"
        },
        aggFunc: "max",
        hide: true,
    },
    {
        field: "cpu_model",
        headerName: "CPU Model",
        hide: true,
    },
    {
        field: "total_mhz",
        type: "numericColumn",
        cellRenderer: integerFormatter,
        headerName: "Total MHz",
        filter: "agNumberColumnFilter",
        aggFunc: "sum",
        hide: true,
    },
    {
        field: "max_cpu_utilization",
        cellRenderer: percentageBarFormatter,
        type: "numericColumn",
        headerName: "Highest % CPU Util",
        aggFunc: "max",
        hide: true,
    },
    {
        field: "avg_ghz_per_cpu",
        type: "numericColumn",
        headerName: "Avg GHz/CPU",
        aggFunc: "avg",
        filter: "agNumberColumnFilter",
        hide: true,
    },
    {
        field: "max_memory_util",
        cellRenderer: percentageBarFormatter,
        type: "numericColumn",
        headerName: "Highest % Memory Util",
        aggFunc: "max",
        filter: "agNumberColumnFilter",
        hide: true,
    },
    {
        field: "total_disk_allocated",
        type: "numericColumn",
        headerName: "Total Disk Allocated",
        cellRenderer: numberFormatter,
        aggFunc: "sum",
        filter: "agNumberColumnFilter",
        hide: true,
    },
    {
        field: "total_disk_used",
        type: "numericColumn",
        headerName: "Total Disk Used",
        cellRenderer: numberFormatter,
        aggFunc: "sum",
        filter: "agNumberColumnFilter",
        hide: true,
    },
    {
        field: "disk_util_pct",
        cellRenderer: percentageBarFormatter,
        type: "numericColumn",
        headerName: "% Disk Used",
        aggFunc: "avg",
        filter: "agNumberColumnFilter",
        hide: true,
    },
    {
        field: "boot_time",
        headerName: "Boot Time",
        hide: true,
    },
    {
        field: "up_time",
        headerName: "Up Time",
        hide: true,
    },
    {
        field: "vm_cpu_build_capacity",
        type: "numericColumn",
        headerName: "VM CPU Build Capacity",
        aggFunc: "sum",
        filter: "agNumberColumnFilter",
        hide: true,
    },
    {
        field: "vm_memory_build_capacity",
        type: "numericColumn",
        headerName: "VM Memory Build Capacity",
        aggFunc: "sum",
        filter: "agNumberColumnFilter",
        hide: true,
    },
    {
        field: "vm_disk_build_capacity",
        type: "numericColumn",
        headerName: "VM Disk Build Capacity",
        aggFunc: "sum",
        filter: "agNumberColumnFilter",
        hide: true,
    },
    {
        field: "cost_per_vm",
        type: "numericColumn",
        headerName: "Cost Per VM",
        aggFunc: "avg",
        filter: "agNumberColumnFilter",
        hide: true,
    },
    {
        field: "number_of_logical_cpus",
        headerName: "Number of Logical CPUs",
        type: "numericColumn",
        cellRenderer: numberFormatter,
        filter: "agNumberColumnFilter",
        aggFunc: "sum",
        hide: true,
    },
    {
        field: "bios_version",
        headerName: "BIOS",
        hide: true,
    },
    {
        field: "firmware",
        headerName: "Firmware",
        hide: true,
    },
    {
        field: "bios_date",
        headerName: "BIOS Date",
        cellRenderer: dateFormatter,
        hide: true,
    },
    {
        field: "hyperthread",
        headerName: "Hyperthread",
        cellRenderer: "booleanFormatter",
        hide: true,
    },
    {
        field: "host_limiting_factor",
        headerName: "Host Limiting Factor",
        hide: true
    },
    {
        field: "device_type_code",
        headerName: "Device Type Code",
        hide: true,
    },
    {
        field: "datacenter_name",
        headerName: "Data Center",
        hide: true,
    },
    {
        field: "tag_1",
        headerName: "Tag 1",
        hide: true,
    },
    {
        field: "tag_2",
        headerName: "Tag 2",
        hide: true,
    },
    {
        field: "tag_3",
        headerName: "Tag 3",
        hide: true,
    },
    {
        field: "state_tag",
        headerName: "State Tag",
        hide: true,
    },
];

export const vmDefs = [
    {
        field: "vm_name",
        headerName: "VM Name"
    },
    {
        field: "num_cpus",
        cellRenderer: numberFormatter,
        type: "numericColumn",
        headerName: "Num CPUs",
        filter: "agNumberColumnFilter",
        aggFunc: "sum"
    },
    {
        field: "vm_util",
        type: "numericColumn",
        headerName: "% CPU Util",
        filter: "agNumberColumnFilter",
        cellRenderer: percentageBarFormatter,
        aggFunc: "avg"
    },
    {
        field: "memory_allocated",
        type: "numericColumn",
        headerName: "Memory Allocated",
        filter: "agNumberColumnFilter",
        cellRenderer: numberFormatter,
        aggFunc: "sum"

    },
    {
        field: "memory_util",
        type: "numericColumn",
        headerName: "% Memory Util",
        filter: "agNumberColumnFilter",
        cellRenderer: percentageBarFormatter,
        aggFunc: "avg"
    },
    {
        field: "disk_allocated",
        type: "numericColumn",
        headerName: "Disk Allocated",
        cellRenderer: integerFormatter,
        filter: "agNumberColumnFilter",
        aggFunc: "sum"
    },
    {
        field: "disk_util_pct",
        type: "numericColumn",
        headerName: "% Disk Used",
        filter: "agNumberColumnFilter",
        cellRenderer: percentageBarFormatter,
        aggFunc: params => usedPct(params, "disk_used", "disk_allocated"),
    },
    {
        field: "os",
        headerName: "OS",
    },
    {
        field: "cluster_name",
        headerName: "Cluster Name"
    },
    {
        field: "vcenter_name",
        headerName: "VCenter Name"
    },
    {
        field: "vsi_capacity_score",
        type: "numericColumn",
        headerName: "VSI Capacity Score",
        filter: "agNumberColumnFilter",
        cellRenderer: capacityScoreFormatter,
        aggFunc: "avg",
        hide: true
    },
    {
        field: "total_mhz",
        type: "numericColumn",
        headerName: "Total Mhz",
        cellRenderer: integerFormatter,
        filter: "agNumberColumnFilter",
        aggFunc: "sum",
        hide: true
    },
    {
        field: "ghz_per_cpu",
        type: "numericColumn",
        headerName: "Ghz / CPU",
        filter: "agNumberColumnFilter",
        aggFunc: "overallAvgPct",
        hide: true
    },
    {
        field: "ghz_used",
        type: "numericColumn",
        headerName: "GHZ Used",
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        cellRenderer: numberFormatter,
        aggFunc: "sum",
        hide: true
    },
    {
        field: "current",
        headerName: "Days Old",
        filter: "agSetColumnFilter",
        cellRenderer: currentFormatter,
        cellStyle: {
            textAlign: "center"
        },
        aggFunc: "max",
        hide: true
    },
    {
        field: "disk_used",
        type: "numericColumn",
        headerName: "Disk Used",
        cellRenderer: integerFormatter,
        filter: "agNumberColumnFilter",
        aggFunc: "sum",
        hide: true,
    },
    {
        field: "disk_provision_type",
        headerName: "Disk Provision Type",
        hide: true,
    },
    {
        field: "overall_status",
        cellStyle: {
            textAlign: "center"
        },
        headerName: "Overall Status",
        hide: true,
    },
    {
        field: "power_state",
        headerName: "Power State",
        cellRenderer: powerStateFormatter,
        hide: true,
    },
    {
        field: "datacenter_name",
        headerName: "Data Center",
        hide: true,
    },
    {
        field: "esx_host_name",
        headerName: "ESX Host Name",
        hide: true,
    },
    {
        field: "cpu_capacity_score",
        type: "numericColumn",
        headerName: "CPU Capacity Score",
        filter: "agNumberColumnFilter",
        cellRenderer: tenProductRound,
        hide: true,
    },
    {
        field: "mem_capacity_score",
        type: "numericColumn",
        headerName: "Memory Capacity Score",
        filter: "agNumberColumnFilter",
        cellRenderer: tenProductRound,
        hide: true,
    },
    {
        field: "disk_capacity_score",
        cellRenderer: tenProductRound,
        type: "numericColumn",
        headerName: "Disk Capacity Score",
        filter: "agNumberColumnFilter",
        hide: true,
    },
    {
        field: "recommended_cpu_size",
        headerName: "Recommended CPU Size",
        type: "numericColumn",
        cellRenderer: integerFormatter,
        filter: "agNumberColumnFilter",
        aggFunc: 'sum',
        hide: true,
    },
    {
        field: "recommended_mem_size",
        headerName: "Recommended Memory Size",
        type: "numericColumn",
        cellRenderer: integerFormatter,
        filter: "agNumberColumnFilter",
        aggFunc: 'sum',
        hide: true,
    },
    {
        field: "recommended_disk_size",
        type: "numericColumn",
        headerName: "Recommended Disk Size",
        cellRenderer: numberFormatter,
        filter: "agNumberColumnFilter",
        aggFunc: 'sum',
        hide: true,
    },
    {
        field: "cpu_rightsize_savings",
        headerName: "CPU Right Size Savings",
        type: "numericColumn",
        cellRenderer: integerFormatter,
        filter: "agNumberColumnFilter",
        hide: true,
    },
    {
        field: "mem_rightsize_savings",
        headerName: "Memory Right Size Savings",
        type: "numericColumn",
        cellRenderer: integerFormatter,
        filter: "agNumberColumnFilter",
        hide: true,
    },
    {
        field: "disk_rightsize_savings",
        type: "numericColumn",
        headerName: "Disk Right Size Savings",
        filter: "agNumberColumnFilter",
        hide: true,
    },
    {
        field: "perf_avg_io_sec",
        type: "numericColumn",
        headerName: "IOPS",
        filter: "agNumberColumnFilter",
        hide: true,
    },
    {
        field: "perf_avg_read_io_sec",
        type: "numericColumn",
        headerName: "Read IOPS",
        filter: "agNumberColumnFilter",
        hide: true,
    },
    {
        field: "total_iops",
        type: "numericColumn",
        headerName: "Total IOPS",
        filter: "agNumberColumnFilter",
        hide: true,
    },
    {
        field: "perf_avg_read_latency",
        type: "numericColumn",
        headerName: "Read Latency",
        filter: "agNumberColumnFilter",
        aggFunc: p => wtAvg(p, "perf_avg_read_latency", "perf_avg_read_io_sec"),
        hide: true,
    },
    {
        field: "avg_latency",
        type: "numericColumn",
        headerName: "Avg Latency",
        filter: "agNumberColumnFilter",
        aggFunc: p => wtAvg(p, "avg_latency", "perf_avg_io_sec"),
        hide: true,
    },
    {
        field: "perf_read_mb_sec",
        type: "numericColumn",
        headerName: "Read MB/Sec",
        filter: "agNumberColumnFilter",
        hide: true,
    },
    {
        field: "perf_write_mb_sec",
        type: "numericColumn",
        headerName: "Write MB/Sec",
        filter: "agNumberColumnFilter",
        hide: true,
    },
    {
        field: "perf_compressed_io_sec",
        type: "numericColumn",
        headerName: "Compressed IOPS",
        filter: "agNumberColumnFilter",
        hide: true,
    },
    {
        field: "perf_compressed_latency",
        type: "numericColumn",
        headerName: "Compressed Latency",
        filter: "agNumberColumnFilter",
        aggFunc: p => wtAvg(p, "perf_compressed_latency", "perf_compressed_io_sec"),
        hide: true,
    },
    {
        field: "perf_avg_cpu_util",
        type: "numericColumn",
        headerName: "AVG CPU Util",
        filter: "agNumberColumnFilter",
        hide: true,
    },
    {
        field: "perf_peak_cpu_util",
        type: "numericColumn",
        headerName: "Peak CPU Util",
        filter: "agNumberColumnFilter",
        hide: true,
    },
    {
        field: "perf_avg_memory_util",
        type: "numericColumn",
        headerName: "AVG Memory Util",
        filter: "agNumberColumnFilter",
        hide: true,
    },
    {
        field: "perf_peak_memory_util",
        type: "numericColumn",
        headerName: "Peak Memory Util",
        filter: "agNumberColumnFilter",
        hide: true,
    },
    {
        field: "perf_avg_mb_sec",
        type: "numericColumn",
        headerName: "AVG MB/Sec",
        filter: "agNumberColumnFilter",
        hide: true,
    },
    {
        field: "perf_peak_mb_sec",
        type: "numericColumn",
        headerName: "Peak MB/Sec",
        filter: "agNumberColumnFilter",
        hide: true,
    },
    {
        field: "cpu_ready",
        type: "numericColumn",
        headerName: "CPU Ready",
        filter: "agNumberColumnFilter",
        aggFunc: "sum",
        hide: true,
    },
    {
        field: "ballooned_memory_pct",
        type: "numericColumn",
        headerName: "Memory Ballooning",
        filter: "agNumberColumnFilter",
        cellRenderer: percentageBarFormatter,
        aggFunc: "overallAvgPct",
        hide: true,
    },
    {
        field: "device_type_code",
        headerName: "Device Type Code",
        hide: true,
    },
    {
        field: "tag_1",
        headerName: "Tag 1",
        hide: true,
    },
    {
        field: "tag_2",
        headerName: "Tag 2",
        hide: true,
    },
    {
        field: "tag_3",
        headerName: "Tag 3",
        hide: true,
    },
    {
        field: "tag_4",
        headerName: "Tag 4",
        hide: true,
    },
    {
        field: "tag_5",
        headerName: "Tag 5",
        hide: true,
    },
    {
        field: "app_tag",
        headerName: "App Tag",
        hide: true,
    },
    {
        field: "env_tag",
        headerName: "Env Tag",
        hide: true,
    },
    {
        field: "state_tag",
        headerName: "State Tag",
        hide: true,
    },
    {
        field: "backup_current",
        headerName: "Backup Current",
        hide: true,
    },
    {
        field: "backup_date",
        headerName: "Backup Date",
        hide: true,
        cellRenderer: dateFormatter,
    },
    {
        field: "state_tag",
        headerName: "State Tag",
        hide: true,
        filter: "agTextColumnFilter",
    }
];

export const hostSummaryDefs = [
    {
        field: "vm_name",
        headerName: "VM Name",
        filter: "agTextColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        }
    },
    {
        field: "num_cpus",
        cellRenderer: numberFormatter,
        type: "numericColumn",
        headerName: "Num CPUs",
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        }
    },
    {
        field: "ghz_per_cpu",
        type: "numericColumn",
        headerName: "Ghz / CPU",
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        cellRenderer: numberFormatter
    },
    {
        field: "total_mhz",
        type: "numericColumn",
        headerName: "Total Mhz",
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        cellRenderer: numberFormatter
    },
    {
        field: "vm_util",
        type: "numericColumn",
        headerName: "% VM Util",
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        cellRenderer: percentageBarFormatter,
    },
    {
        field: "memory_allocated",
        type: "numericColumn",
        headerName: "Memory Allocated",
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        cellRenderer: numberFormatter
    },
    {
        field: "memory_util",
        type: "numericColumn",
        headerName: "% Memory Util",
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        cellRenderer: percentageBarFormatter,
    },
    {
        field: "disk_allocated",
        type: "numericColumn",
        headerName: "Disk Allocated",
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        cellRenderer: numberFormatter
    },
    {
        field: "disk_used",
        type: "numericColumn",
        headerName: "Disk Used",
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        cellRenderer: numberFormatter
    },
    {
        field: "disk_util_pct",
        type: "numericColumn",
        headerName: "% Disk Used",
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        cellRenderer: percentageBarFormatter,
    },
    {
        field: "os",
        headerName: "OS",
        hide: true
    },
    {
        field: "overall_status",
        cellStyle: {
            "text-align": "center"
        },
        headerName: "Overall Status",
        hide: true
    },
    {
        field: "datacenter_name",
        headerName: "Datacenter Name",
        hide: true
    },
    {
        field: "esx_host_name",
        headerName: "ESX Host Name",
        hide: true
    },
    {
        field: "cluster_name",
        headerName: "Cluster Name",
        hide: true
    },
    {
        field: "device_type_code",
        headerName: "Device Type Code",
        hide: true
    }
]
